<template>
  <section v-if="agreements" class="my-agreements">
    <h6 class="ms-1 mb-5 mt-2 text-gray-700">На согласование</h6>
    <div class="my-agreements__list mb-5">
      <div v-for="(item, key) in agreements" class="my-agreements_item rounded bg-white p-5 pulse mb-3">
        <div class="my-agreements_item__icon">
          <i class="ki-duotone ki-notification-on text-primary fs-1">
            <span class="path1"></span>
            <span class="path2"></span>
            <span class="path3"></span>
            <span class="path4"></span>
            <span class="path5"></span>
          </i>
        </div>
        <div class="my-agreements_item__info">
          <div class="fs-6 fw-bolder text-gray-700 line-clamp">{{ item.title }}</div>
          <div class="fs-8 text-gray-400">{{ item.description }}</div>
        </div>
        <div class="my-agreements_item__link">
          <i @click="openMyAgreementModal(key)" class="ki-outline ki-right-square text-primary fs-4 cursor-pointer"></i>
        </div>
      </div>
    </div>
  </section>
  <my-agreements-modal v-if="showModal" :agreement="changeAgreement" @close="closeMyAgreementModal" />
</template>

<script>
import MyAgreementsModal from '@/components/Agreement/MyAgreementsModal'

export default {
  name: 'MyAgreementsList',
  components: {MyAgreementsModal},
  props: {
    agreements: {
      type: Array,
      required: true
    }
  },
  mounted() {
  },
  data() {
    return {
      loader: false,
      changeAgreement: null,
      showModal: false
    }
  },
  methods: {
    openMyAgreementModal(key) {
      this.changeAgreement = structuredClone(this.agreements[key])
      this.showModal = true
      setTimeout(() => new bootstrap.Modal('#myAgreementModal', {}).show(), 10)
    },
    closeMyAgreementModal(val) {
      bootstrap.Modal.getInstance(document.getElementById('myAgreementModal')).hide();
      this.changeAgreement = null
      this.showModal       = false
      if (val.update) this.$store.dispatch('agreementsRequest')
    }
  }
}
</script>

<style scoped>

</style>